import OpenedBox from './OpenedBox';

export default OpenedBox;
